type ProductTourStatus = "completed" | "skipped" | null

export interface User {
  id: string
  firstName: string
  lastName: string
  universityId: string
  externalId: string
  role: UserRole
  dailyStudyHours: number
  profilePicUrl: string
  emailAddress: string
  sex: UserSex
  timeZone: string
  wasOnboarded: boolean
  productTour: ProductTourStatus
}

export enum UserRole {
  STUDENT = "student",
  SUPERVISOR = "supervisor",
}

export enum UserSex {
  F = "F",
  M = "M",
  X = "X",
}
